function formatUrl(url, params) {
  let operater = url.indexOf('?') === -1 ? '?' : '&';
  const { hasOwnProperty } = Object.prototype;
  if (params) {
    for (const key in params) {
      if (hasOwnProperty.call(params, key)) {
        url += `${operater + key}=${params[key]}`;
        operater = '&';
      }
    }
  }
  return url;
}
// 用来缓存postMsg过来的视频状态信息
let msgData = {};
// 接收消息
function receiveMsg(cb, target = window) {
  const listener = function (e) {
    const postMsg = e.data;
    if (postMsg) {
      try {
        msgData = JSON.parse(postMsg);
        console.log('[receiveMsg]', msgData);
      } catch (ex) {
        console.warn(`PostMsg Parse Error ${postMsg}`, ex);
        return;
      }
      typeof cb === 'function' ? cb(msgData) : '';
    } else {
      return;
    }
  };
  target.addEventListener('message', listener);
}
function getMobileSize() {
  const doc = document.documentElement || document.body;
  const w = doc.clientWidth;
  const h = doc.clientHeight;
  const { scrollTop } = doc;
  return {
    w,
    h,
    scrollTop,
  };
}
// State统一定时器
const stateTimer = (function () {
  const stateTimers = [];
  function make(func, options) {
    clear(options.id);
    stateTimers[options.id] = setTimeout(func, options.delay);
  }
  function clear(id) {
    stateTimers[id] && clearTimeout(stateTimers[id]);
  }
  return {
    make,
    clear,
  };
}());
// 环境判断
const isOa = /^oa.*.qq.com/.test(location.host);
const isGray = /chat.*?-gray/.test(location.href);
const ua = navigator.userAgent.toLowerCase();
const isWXWork = ua.match(/wxwork/i) == 'wxwork';
const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger';
const isMiniprogram = window.__wxjs_environment === 'miniprogram';
let miniProgramOriginId = isOa ? 'gh_80dc8192b287' : 'gh_97d7d14a21da';
const grayMinprogramId = 'gh_2b6018df09ef';
if (isGray) {
  miniProgramOriginId = grayMinprogramId;
}
if (!isOa) {
  // 灰度和线上环境都跳转灰度视频客服独立版小程序
  miniProgramOriginId = grayMinprogramId;
}
export {
  formatUrl,
  isOa,
  stateTimer,
  isWeixin,
  isMiniprogram,
  miniProgramOriginId,
  receiveMsg,
  getMobileSize,
};
